var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-light bg-light sticky-top"},[_vm._t("menu"),_vm._t("functions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }